export function getPermissionTable() {
  try {
    return JSON.parse(localStorage.getItem("permissionTable")) || { permissions: [], features: [] };
  } catch {
    return { permissions: [], features: [] };
  }
}

export function hasPermission(key) {
  return getPermissionTable().permissions.includes(key);
}

export function hasFeature(key) {
  return getPermissionTable().features.includes(key);
}

// Non-hook static reads (safe to call conditionally / inside useMemo bodies).
export function usePermissionAnyStatic(keys) {
  const { permissions } = getPermissionTable();
  return (keys || []).some((k) => permissions.includes(k));
}

// React-hook wrappers (read once per render; permission table changes only on login/refresh).
export function usePermission(key) {
  return hasPermission(key);
}

export function useFeature(key) {
  return hasFeature(key);
}

export function usePermissionAny(keys) {
  return usePermissionAnyStatic(keys);
}
